import { useBrandStore } from '@bv/stores';
import { watch } from 'vue';
import VueCookies from 'vue-cookies';

import pinia from '@/plugins/pinia';

const isHttps = window.location.protocol === 'https:';
const SameSite: string = isHttps ? 'None' : 'Lax';

const applyCookieConfig = (domain: string): void => {
  // @ts-expect-error Don't know why this is needed
  VueCookies.config(0, '/', `.${domain}`, isHttps, SameSite);
};

const brandStore = useBrandStore(pinia);

watch(
  () => brandStore.config?.domain,
  (domain) => {
    if (domain) {
      applyCookieConfig(domain);
    }
  },
  { immediate: true },
);

export function getItem(key: string): any {
  // @ts-expect-error Don't know why this is needed
  return VueCookies.get(key);
}

export function setItem(key: string, value: any): void {
  // @ts-expect-error Don't know why this is needed
  VueCookies.set(key, value);
}

export function removeItem(key: string): void {
  // @ts-expect-error Don't know why this is needed
  VueCookies.remove(key);
}

export function removeAll(): void {
  // @ts-expect-error Don't know why this is needed
  VueCookies.keys().forEach((cookieName: string) => {
    // @ts-expect-error Don't know why this is needed
    VueCookies.remove(cookieName);
  });
}
